import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileTypeService {

  readonly image_extensions = ['png', 'jpeg', 'jpg', 'bmp', 'gif'];
  readonly excel_extensions = ['xls', 'xlsx'];
  readonly movie_extensions = ['mp4', 'wmv', 'mov', 'flv', 'm4v'];
  readonly cert_extensions = ['cer', 'pem', 'der', 'crt', 'p7b', 'pfx', 'p12'];
  readonly certPrivKey_extensions = ['key'];
  readonly knownFiles = ['avi', 'doc', 'docx', 'xls', 'xlsx', 'mp3', 'mp4', 'pdf', 'ppt', 'pptx', 'svg','eml','sms','csv','xml','zip'];
  readonly defaultIcontype = "./assets/img/fileTypes/unknown.png";

  public isFileImage(fileExtension: string): boolean {

    return this.image_extensions.includes(this.normalizeExtension(fileExtension));
  }

  public isMovieFile(fileExtension: string): boolean {

    return this.movie_extensions.includes(this.normalizeExtension(fileExtension));
  }

  public isKnownFile(fileExtension: string): boolean {

    return this.knownFiles.includes(this.normalizeExtension(fileExtension));
  }

  public getFileTypeIcon(fileExtension: string): string {

    fileExtension = this.normalizeExtension(fileExtension);
    if (this.isFileImage(fileExtension)) {
      return "./assets/img/fileTypes/image.png";
    }

    if (this.isMovieFile(fileExtension)) {
      return "./assets/img/fileTypes/movie.png";
    }

    if (this.isKnownFile(fileExtension)) {
      return "./assets/img/fileTypes/" + fileExtension + ".png";
    }

    return this.defaultIcontype;
  }

  private normalizeExtension(fileExtension:string): string {
    return fileExtension.toLowerCase().replace('.', '');
  }

  public getContentType(fileExtension: string): string {

    fileExtension = this.normalizeExtension(fileExtension);

    switch(fileExtension){
      case "pdf" : return "application/pdf";
      case "xml" : return "application/xml";
      case "txt" : return "text/plain";
      case "png" : return "image/png";
      case "jpg" : return "image/jpeg";
      case "jpeg" : return "image/jpeg";
      default:
        return "application/octet-stream";
    }
  }
}
